import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Box, Grid, Typography } from "@mui/material";
import { clientsApi, usersApi, usinasApi } from "../../../services/api";
import Loading from "../../../main/components/Loading";
import { UserDetailsHeader } from "../components/UserDetailsHeader";
import { ItemsDetails } from "../../../main/components/ItemsDetails";
import { Usina } from "../../usinas/types";
import { Item } from "../components/UserItemsTable";
import { UserDetailsNotificationToggleItems } from "../components/UserDetailsNotificationToggleItems";
import { UserDetailsFooter } from "../components/UserDetailsFooter";
import UserDetailsInfos from "../components/UserDetailsInfos";
import { ResetPasswordModals } from "../components/ResetPasswordModals";
import { RemoveUsinaModals } from "../components/RemoveUsinaModals";
// import { RemoveClientModals } from "../components/RemoveClientModals";
import { RemoveRoleModals } from "../components/RemoveRoleModals";
import { AddItemModals } from "../components/AddItemModals";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import UserClientItem from "../components/UserClientItem";
import {
  NotificationConfiguration,
  User,
  UserClient,
  UserRoles,
  WhatsappNotificationConfiguration,
} from "../types";
import { UserDetailsWhatsappToggleItems } from "../components/UserDetailsWhatsappToggleItems";
import { MainContext } from "../../../main/context/MainContextProvider";
import { Client } from "../../clients/types";

export const allRoles = [
  {
    id: "Administrador",
    name: "Administrador",
  },
  {
    id: "Cliente",
    name: "Cliente",
  },
  {
    id: "Técnico",
    name: "Técnico",
  },
  {
    id: "Manutenção",
    name: "Manutenção",
  },
];

export default function UserDetails() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [usinas, setUsinas] = useState<Usina[]>([]);
  const [clients, setClients] = useState<Client[]>([]);
  const [userClients, setUserClients] = useState<UserClient[]>([]);
  const [selectedClient, setSelectedClient] = useState<Item | null>(null);

  const [showPasswordResetModal, setShowPasswordResetModal] =
    useState<boolean>(false);
  const [selectedUsina, setSelectedUsina] = useState<Item | null>(null);

  const [allRoles, setAllRoles] = useState<Item[]>([]);
  const [selectedRole, setSelectedRole] = useState<Item | null>(null);
  const [showRemoveUsinaModal, setShowRemoveUsinaModal] =
    useState<boolean>(false);
  // const [showRemoveClientModal, setShowRemoveClientModal] =
  //   useState<boolean>(false);
  const [showRemoveRoleModal, setShowRemoveRoleModal] =
    useState<boolean>(false);
  const [showAddUsinaModal, setShowAddUsinaModal] = useState<boolean>(false);
  const [showAddClientModal, setShowAddClientModal] = useState<boolean>(false);
  const [showAddRoleModal, setShowAddRoleModal] = useState<boolean>(false);
  const [notificationConfiguration, setNotificationConfiguration] = useState<
    NotificationConfiguration | undefined
  >();
  const [
    whatsappNotificationConfiguration,
    setWhatsappNotificationConfiguration,
  ] = useState<WhatsappNotificationConfiguration | undefined>();
  const path = window.location.pathname;
  const userId = path.split("/")[2];

  const onResetPassword = () => {
    setShowPasswordResetModal(true);
  };
  const onConfirmResetPassword = async () => {
    if (!user) return;
    await usersApi.resetPassword(user?.email);
  };
  const onRemoveUsina = async (item: Item) => {
    setSelectedUsina(item);
    setShowRemoveUsinaModal(true);
  };
  const onConfirmRemoveUsina = async () => {
    if (!selectedUsina || !selectedUserClient) return;
    await usersApi.removeUsina(
      user?.email ?? "",
      selectedUserClient.id ?? "",
      selectedUsina.id ?? ""
    );
  };
  // const onRemoveClient = async (item: Item) => {
  //   setSelectedClient(item);
  //   setShowRemoveClientModal(true);
  // };
  // const onConfirmRemoveClient = async () => {
  //   if (!selectedClient) return;
  //   await usersApi.removeClient(userId, selectedClient.id);
  // };
  const onRemoveRole = async (item: Item) => {
    if (item.name === UserRoles.User || item.name === UserRoles.Client) {
      return;
    }
    setSelectedRole(item);
    setShowRemoveRoleModal(true);
  };
  const onConfirmRemoveRole = async () => {
    if (!selectedRole || !selectedUserClient) return;
    if (selectedUserClient)
      await usersApi.removeRole(
        user?.email ?? "",
        selectedUserClient.id,
        selectedRole.id ?? ""
      );
  };

  const onConfirmAddUsina = async (item: Item) => {
    if (selectedUserClient)
      await usersApi.addUsina(
        user?.email ?? "",
        selectedUserClient.id,
        item.id ?? ""
      );
  };
  const onConfirmAddClient = async (item: Item) => {
    await usersApi.addClient(userId, item.id ?? "");
  };
  const onConfirmAddRole = async (item: Item) => {
    if (selectedUserClient)
      await usersApi.addRole(
        user?.email ?? "",
        selectedUserClient.id,
        item.id ?? ""
      );
  };
  useEffect(() => {
    onMount();
  }, []);

  useEffect(() => {
    if (selectedClient) {
      const userClient = userClients.find((r) => r.id == selectedClient.id);
      if (userClient) {
        setWhatsappNotificationConfiguration(
          userClient.whatsappNotificationConfiguration
        );
      }
    }
  }, [selectedClient]);

  const { toastNotifications, setToastNotifications } = useContext(MainContext);

  const onMount = async () => {
    setLoading(true);
    try {
      const userResponse = await usersApi.getUser(userId);
      const usinasResponse = await usinasApi.getUsinas();
      const clientsResponse = await clientsApi.getClients();
      setUserClients(userResponse.clients);
      if (userResponse.clients.length > 0) {
        const firtsClient = userResponse.clients[0];
        setSelectedClient(firtsClient);
        setWhatsappNotificationConfiguration(
          firtsClient.whatsappNotificationConfiguration
        );
      }
      if (userResponse.clients.length <= 0) {
        const newNotifications = {
          isAdding: true,
          notifications: [
            ...toastNotifications.notifications,
            {
              severity: "warning" as const,
              text: "O usuário não é associado a nenhum cliente, associe-o para ter acesso a área do cliente",
            },
          ],
        };
        setToastNotifications(newNotifications);
      }
      setUsinas(usinasResponse.data);
      setClients(clientsResponse.data);
      setUser(userResponse);
      setNotificationConfiguration(userResponse.notificationConfiguration);
      const rolesResponse = await usersApi.getAllRoles();
      setAllRoles(rolesResponse);
      // TODO: implementar get de clientes do usuário assim que a api estiver pronta
    } catch (error) {
      setUser(null);
      if (axios.isAxiosError(error)) {
        ("Erro ao coletar os dados do usuário");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userClients.length > 0 && !selectedClient) {
      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "error" as const,
            text: "Não foi encontrado nenhum cliente para o usuário, selecione um cliente para ter acesso a área do cliente",
          },
        ],
      };
      setToastNotifications(newNotifications);
      console.error("Não foi encontrado nenhum cliente para o Usuário")
    } else if (userClients.length > 0) {
      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "info" as const,
            text: `Cliente ${selectedClient?.name ?? ""} selecionado para área do cliente`,
          },
        ],
      };
      setToastNotifications(newNotifications);
      console.error(`Cliente ${selectedClient?.name ?? ""} selecionado para área do cliente`)
    }
  }, [selectedClient])

  const selectedUserClient = userClients.find(
    (r) => r.id == selectedClient?.id
  );

  const currentClient = clients.find((client) => client.id == selectedClient?.id);

  const currentClientUsinas = usinas.filter((usina) => currentClient?.usinasIds?.includes(usina.usinaIds.id))

  const selectedClientUsinas = usinas.filter((usina) =>
    selectedUserClient?.usinas.includes(usina.usinaIds.id)
  );
  const userRoles =
    selectedUserClient?.roles
      .map((role) => ({
        id: role,
        name: role,
        cantRemove: role === UserRoles.User || role === UserRoles.Client,
      }))
      .filter(
        (role) =>
          role.name == UserRoles.Client ||
          allRoles.map((r) => r.name).includes(role.name)
      ) || [];

  const roles = allRoles
    .filter((role) => !userRoles.map((r) => r.name).includes(role.name ?? ""))
    .map((role) => {
      return {
        id: role.name ?? "",
        name: role.name,
      };
    });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: loading ? "center" : "start",
        width: "100%",
        height: "100%",
        padding: { sm: "20px", xs: "10px" },
        rowGap: "20px",
      }}
    >
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {user ? (
            <Grid
              container
              columnSpacing={2}
              padding={{
                xs: "10px",
                sm: "20px",
              }}
            >
              <UserDetailsHeader user={user} onMount={onMount} />
              <UserDetailsInfos user={user} onMount={onMount} />
              {notificationConfiguration && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ padding: "none" }}
                  textAlign={"start"}
                >
                  <UserDetailsNotificationToggleItems
                    configuration={notificationConfiguration}
                    setConfiguration={setNotificationConfiguration}
                    label="Notificações"
                    defaultConfiguration={user.notificationConfiguration}
                    userId={userId}
                    onMount={onMount}
                  />
                </Grid>
              )}
              {userClients.length > 0 &&
                <>
                  <Grid item xs={12} textAlign={"center"}>
                    <Typography
                      sx={{
                        borderBottom: "1px solid #ccc",
                        paddingBottom: 1,
                        marginBottom: "15px",
                        marginTop: "40px",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    // sx={{
                    //   fontWeight: "bold",
                    //   fontSize: "18px",
                    //   marginTop: "40px",
                    //   marginBottom: "16px",
                    // }}
                    >
                      Área do Cliente
                    </Typography>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        overflow: "auto",
                      }}
                      xs={12}
                    >
                      {userClients.map((client, i) => (
                        <UserClientItem
                          onClick={() => {
                            setSelectedClient(client);
                          }}
                          isSelected={client.id === selectedClient?.id}
                          title={client.name ?? ""}
                          key={i}
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item display={"flex"} xs={12} sm={6}>
                    <ItemsDetails
                      items={selectedClientUsinas.map((usina) => {
                        return {
                          id: usina.usinaIds.id,
                          name: usina.name,
                        };
                      })}
                      label="Usinas"
                      itemLabel="usina"
                      onAdd={() => {
                        setShowAddUsinaModal(true);
                      }}
                      style={{
                        display: "flex",
                        alignItems: selectedClientUsinas.length > 0 ? "flex-start" : "center",
                        height: "100%",
                      }}
                      onRemove={onRemoveUsina}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                <UserDetailsItems
                  items={userClients}
                  label="Clientes"
                  itemLabel="cliente"
                  onAdd={() => {
                    setShowAddClientModal(true);
                  }}
                  onRemove={onRemoveClient}
                />
              </Grid> */}

                  <Grid item xs={12} sm={6} textAlign={"start"}>
                    <ItemsDetails
                      items={userRoles}
                      label="Perfis"
                      itemLabel="perfil"
                      onAdd={() => {
                        setShowAddRoleModal(true);
                      }}
                      style={{
                        display: "flex",
                        alignItems: userRoles.length > 0 ? "flex-start" : "center",
                        height: "100%",
                      }}
                      onRemove={onRemoveRole}
                    />
                  </Grid>
                </>
              }
              {selectedUserClient &&
                whatsappNotificationConfiguration?.canReceiveWhatsappNotification && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ padding: "none" }}
                    textAlign={"start"}
                  >
                    <UserDetailsWhatsappToggleItems
                      clientId={selectedUserClient.id}
                      whatsAppConfiguration={whatsappNotificationConfiguration}
                      setWhatsappConfiguration={
                        setWhatsappNotificationConfiguration
                      }
                      label="Notificações de Whatsapp"
                      defaultWhatsappConfiguration={
                        selectedUserClient.whatsappNotificationConfiguration
                      }
                      userEmail={user.email}
                      onMount={onMount}
                    />
                  </Grid>
                )}
              <Grid item sm={12} xs={12}>
                <UserDetailsFooter onResetPassword={onResetPassword} />
              </Grid>
              <ResetPasswordModals
                onConfirmResetPassword={onConfirmResetPassword}
                showPasswordResetModal={showPasswordResetModal}
                setShowPasswordResetModal={setShowPasswordResetModal}
                onMount={onMount}
              />
              <RemoveUsinaModals
                onConfirmRemoveUsina={onConfirmRemoveUsina}
                showRemoveUsinaModal={showRemoveUsinaModal}
                setShowRemoveUsinaModal={setShowRemoveUsinaModal}
                usinaName={selectedUsina?.name || ""}
                onMount={onMount}
              />
              {/* <RemoveClientModals
                onConfirmRemoveClient={onConfirmRemoveClient}
                showRemoveClientModal={showRemoveClientModal}
                setShowRemoveClientModal={setShowRemoveClientModal}
                clientName={selectedClient?.name || ""}
              /> */}
              <RemoveRoleModals
                onConfirmRemoveRole={onConfirmRemoveRole}
                showRemoveRoleModal={showRemoveRoleModal}
                setShowRemoveRoleModal={setShowRemoveRoleModal}
                roleName={selectedRole?.name || ""}
                onMount={onMount}
              />
              <AddItemModals
                itemName="Usina"
                itemText="a usina"
                items={currentClientUsinas
                  .filter(
                    (usina) =>
                      !selectedClientUsinas
                        .map((u) => u.usinaIds.id)
                        .includes(usina.usinaIds.id)
                  )
                  .map((usina) => {
                    return {
                      id: usina.usinaIds.id,
                      name: usina.name,
                    };
                  })}
                onConfirmAddItem={onConfirmAddUsina}
                setShowAddItemModal={setShowAddUsinaModal}
                showAddItemModal={showAddUsinaModal}
                onMount={onMount}
                showApiErrorMessage
              />
              <AddItemModals
                itemName="Cliente"
                itemText="o cliente"
                items={userClients}
                onConfirmAddItem={onConfirmAddClient}
                setShowAddItemModal={setShowAddClientModal}
                showAddItemModal={showAddClientModal}
                onMount={onMount}
              />
              <AddItemModals
                itemName="Perfil"
                itemText="o perfil"
                items={roles}
                onConfirmAddItem={onConfirmAddRole}
                setShowAddItemModal={setShowAddRoleModal}
                showAddItemModal={showAddRoleModal}
                onMount={onMount}
              />
            </Grid>
          ) : (
            <EmptyStateNotFound />
          )}
        </>
      )}
    </Box>
  );
}
